import Input from "@/components/controls/input";
import Button from "@/components/controls/button";
import ShadowScrollContainer from "@/components/shadow-scroll-container";
import ColumnsForm from "../form";
import CSidesheet from "@/components/sidesheet";
import ErrorFeedback from "@/components/error-feedback";

export default {
    name: "table-columns-modal",

    props: ["columns", "defaultSelected"],

    components: {
        "c-input": Input,
        "c-button": Button,
        ShadowScrollContainer,
        ColumnsForm,
        CSidesheet,
        ErrorFeedback,
    },

    data() {
        return {
            id: null,
            isOpen: false,
            search: "",
            selected: [],
            title: "Настройки столбцов",
        };
    },

    methods: {
        open(id, config) {
            this.search = "";
            this.id = id;
            if ("title" in config) this.title = config.title;
            this.selected = config.columns;
            this.isOpen = true;
        },

        close() {
            this.id = null;
            this.isOpen = false;
        },

        apply() {
            this.$emit("apply", {
                id: this.id,
                selected: this.getSelectedColumns(),
            });
            this.close();
        },

        getSelectedColumns() {
            const columns = [];

            this.selected.forEach((column) => {
                const columnObject = this.columns.find((c) => c.code === column);
                if (columnObject.parentColumnId && !columns.includes(columnObject.parentColumnId)) {
                    columns.push(columnObject.parentColumnId);
                }
                columns.push(column);
            });

            return columns;
        },

        reset() {
            this.close();
        },
    },
};
